import { Command } from './Commands';

export class RenamePage extends Command {
  priority: number = 100;
  constructor(public values: string[], id: string) {
    super(values, id);
  }
  type: string = 'Page.Rename';
}
